var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 407.387,
    height: 340.653,
    viewBox: "0 0 407.387 340.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(-230.006 -186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M980.985,745.077a72.1,72.1,0,0,0,.751-9.831c0-40.2-33.023-72.791-73.759-72.791a73.8,73.8,0,0,0-67.97,44.478,51.675,51.675,0,0,0-34.226-12.906c-28.466,0-51.542,22.773-51.542,50.865h-9.618c-27.371,0-49.765,22.1-49.765,49.112h0c0,27.011,22.394,49.111,49.765,49.111H977.313c27.37,0,49.764-22.1,49.764-49.111h0C1027.078,768.216,1006.652,746.954,980.985,745.077Z",
    transform: "translate(-464.85 -476.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 109.059,
    cy: 109.059,
    r: 109.059,
    transform: "translate(341.005 225.667)",
    fill: "none",
    stroke: "#333f4f",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M4.138,0h67.9a3.942,3.942,0,0,1,4.138,3.71V54.789a3.942,3.942,0,0,1-4.138,3.71H4.138A3.942,3.942,0,0,1,0,54.789V3.71A3.942,3.942,0,0,1,4.138,0Z",
    transform: "translate(521.034 325.778)",
    fill: "#f7f7f7",
    stroke: "#fd9827",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M817.829,1277.35H771.907a2.74,2.74,0,0,1-2.732-2.732h0a2.74,2.74,0,0,1,2.732-2.732h45.922a2.74,2.74,0,0,1,2.732,2.732h0A2.74,2.74,0,0,1,817.829,1277.35Z",
    transform: "translate(-235.645 -916.006)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M817.829,1328.464H771.907a2.74,2.74,0,0,1-2.732-2.732h0a2.74,2.74,0,0,1,2.732-2.732h45.922a2.74,2.74,0,0,1,2.732,2.732h0A2.74,2.74,0,0,1,817.829,1328.464Z",
    transform: "translate(-235.645 -959.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M817.829,1328.464H771.907a2.74,2.74,0,0,1-2.732-2.732h0a2.74,2.74,0,0,1,2.732-2.732h45.922a2.74,2.74,0,0,1,2.732,2.732h0A2.74,2.74,0,0,1,817.829,1328.464Z",
    transform: "translate(-235.645 -967.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(542.913 365.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M825.6,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,825.6,1335.651Z",
    transform: "translate(-823.676 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M844.756,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,844.756,1335.651Z",
    transform: "translate(-839.534 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M863.912,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,863.912,1335.651Z",
    transform: "translate(-855.392 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M883.069,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,883.069,1335.651Z",
    transform: "translate(-871.251 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M902.225,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,902.225,1335.651Z",
    transform: "translate(-887.109 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M921.381,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,921.381,1335.651Z",
    transform: "translate(-902.967 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M940.537,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,940.537,1335.651Z",
    transform: "translate(-918.825 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M959.694,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,959.694,1335.651Z",
    transform: "translate(-934.684 -1334.689)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M978.85,1335.651a.962.962,0,1,1-.962-.962A.962.962,0,0,1,978.85,1335.651Z",
    transform: "translate(-950.542 -1334.689)",
    fill: "#e9eaeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(548.682 330.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M10.556,0A10.556,10.556,0,1,1,0,10.556,10.556,10.556,0,0,1,10.556,0Z",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(4.688 3.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(2.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M902.577,1131.673a3.335,3.335,0,0,0,2.59-1.269,3.251,3.251,0,0,0,.714-2.062,3.317,3.317,0,1,0-6.633,0,3.247,3.247,0,0,0,.713,2.062A3.347,3.347,0,0,0,902.577,1131.673Z",
    transform: "translate(-899.247 -1125.013)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M896.149,1174.058c0,2.1-11.735,2.1-11.735,0l0-2.449c.464-3.348,10.777-3.488,11.733,0Z",
    transform: "translate(-884.414 -1161.464)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M787.15,1330.07v-.146a1.075,1.075,0,1,0-2.15,0v.146h-.163v1.938c0,.335,2.483.335,2.483,0v-1.937Zm-1.767-.146a.7.7,0,1,1,1.391,0v.146h-1.391Zm.875,1.122v.56a.178.178,0,0,1-.187.172.165.165,0,0,1-.172-.172v-.56a.326.326,0,0,1-.173-.287.345.345,0,0,1,.689,0A.346.346,0,0,1,786.258,1331.046Z",
    transform: "translate(-248.61 -964.103)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(536.213 357.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(0.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M788.666,1279.847a.7.7,0,0,0,.547-.268.686.686,0,0,0,.151-.435.7.7,0,1,0-1.4,0,.685.685,0,0,0,.151.435A.706.706,0,0,0,788.666,1279.847Z",
    transform: "translate(-787.963 -1278.442)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M787.248,1288.791c0,.443-2.489.443-2.489,0l.014-.517c.1-.706,2.274-.736,2.476,0Z",
    transform: "translate(-784.759 -1286.134)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M833.229,1284.7H823.166a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h10.064a.8.8,0,0,1,.8.8h0A.8.8,0,0,1,833.229,1284.7Z",
    transform: "translate(-815.89 -1282.297)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M910.323,1284.7H900.26a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h10.064a.8.8,0,0,1,.8.8h0A.8.8,0,0,1,910.323,1284.7Z",
    transform: "translate(-879.711 -1282.297)",
    fill: "#e9eaeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M2.341,0h9.12A2.341,2.341,0,0,1,13.8,2.341h0a2.341,2.341,0,0,1-2.341,2.341H2.341A2.341,2.341,0,0,1,0,2.341H0A2.341,2.341,0,0,1,2.341,0Z",
    transform: "translate(551.129 371.074)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(314.133 317.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M244.649,850.166h0c0-.09,0-.13,0-.139C244.649,850.044,244.649,850.166,244.649,850.166Z",
    transform: "translate(-244.578 -835.665)",
    fill: "#d9ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M244.649,850.166h0c0-.09,0-.13,0-.139C244.649,850.044,244.649,850.166,244.649,850.166Z",
    transform: "translate(-244.578 -835.665)",
    fill: "#d9ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M505.384,851.332s0-.122,0-.139c0,.009,0,.049,0,.139Z",
    transform: "translate(-451.642 -836.591)",
    fill: "#d9ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M505.384,851.332s0-.122,0-.139c0,.009,0,.049,0,.139Z",
    transform: "translate(-451.642 -836.591)",
    fill: "#d9ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M271.321,780.259c-6.254,6.7-16.235,12.19-26.914,14.53,0,.713-.021,4.665-.1,22.879-.109,24.3,23.015,36.171,26.605,37.993,3.479-1.6,26.894-13.456,27-37.754.082-18.214.1-22.166.1-22.879C287.356,792.594,277.515,787.014,271.321,780.259Z",
    transform: "translate(-244.304 -780.259)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(2.92 4.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M282.521,801.592c-6.125,5.619-14.61,10.035-23.941,12.442l-.092,20.586c-.042,9.42,3.7,17.941,11.123,25.329a53.206,53.206,0,0,0,12.607,9.218c.112-.057.235-.121.355-.184V801.64Z",
    transform: "translate(-258.488 -801.592)",
    fill: "#e9eaeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(24.086 0.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M375.5,801.825v67.344a53.234,53.234,0,0,0,12.334-8.921c7.488-7.321,11.307-15.809,11.349-25.229l.092-20.587C389.991,811.949,381.569,807.475,375.5,801.825Z",
    transform: "translate(-375.499 -801.825)",
    fill: "#f7f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(330.297 340.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M322.831,945.973v15.949c0,1.775,21.683,1.775,21.683,0V945.973Zm11.938,8.469v4.52a1.1,1.1,0,1,1-2.194,0v-4.53a2.667,2.667,0,1,1,2.194.01Z",
    transform: "translate(-322.831 -934.819)",
    fill: "#fd9827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M349.944,901.805h-2.195v-1.074a6.748,6.748,0,1,0-13.5,0v1.074h-2.195v-1.074a8.943,8.943,0,1,1,17.886,0Z",
    transform: "translate(-330.159 -891.788)",
    fill: "#fd9827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(419.368 193.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 39.168,
    height: 48.89,
    fill: "#fff",
    stroke: "#e9eaeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(424.447 198.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 39.168,
    height: 48.89,
    fill: "#e9eaeb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(430.898 203.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 39.168,
    height: 48.89,
    fill: "#e9eaeb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(435.591 208.749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 39.168,
    height: 48.89,
    fill: "#fff",
    stroke: "#e9eaeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 20.26,
    height: 3.18,
    transform: "translate(12.814 8.027)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 26.252,
    height: 3.18,
    transform: "translate(6.822 15.497)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 26.252,
    height: 3.18,
    transform: "translate(6.822 22.968)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 26.252,
    height: 3.18,
    transform: "translate(6.822 30.439)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 26.252,
    height: 3.18,
    transform: "translate(6.822 37.909)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(335.327 245.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M459,303.871a25.382,25.382,0,0,0,3.39-9.434l1.03.151,2.035.3.026,0a28.416,28.416,0,0,0-.535-11.053l-3.027.75a25.39,25.39,0,0,0-4.282-9.062l2.509-1.865a28.3,28.3,0,0,0-8.192-7.446l-1.616,2.68a25.335,25.335,0,0,0-9.433-3.39l.452-3.092a28.6,28.6,0,0,0-11.053.535l.75,3.027a25.391,25.391,0,0,0-9.062,4.282l-1.865-2.509a28.3,28.3,0,0,0-7.446,8.192l2.681,1.617a25.337,25.337,0,0,0-3.391,9.433l-2.187-.322-.894-.124-.01-.006a28.6,28.6,0,0,0,.534,11.052l3.028-.75a25.438,25.438,0,0,0,4.292,9.068l-2.509,1.865a28.239,28.239,0,0,0,8.182,7.44l1.617-2.681a25.4,25.4,0,0,0,9.443,3.4l-.355,2.4-.1.689a28.545,28.545,0,0,0,11.042-.541l-.749-3.027a25.656,25.656,0,0,0,9.078-4.286l1.865,2.509a28.452,28.452,0,0,0,7.43-8.188Zm-28.964-1.309a13.83,13.83,0,1,1,18.984-4.71A13.829,13.829,0,0,1,430.032,302.562Z",
    transform: "translate(-408.57 -262.106)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(313.551 278.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M301.862,427.643a13.366,13.366,0,0,0-3.72-3.744l.3-.456.6-.9.007-.012a14.961,14.961,0,0,0-5.377-2.243l-.328,1.609a13.371,13.371,0,0,0-5.277-.011l-.32-1.615a14.9,14.9,0,0,0-5.392,2.213l.909,1.374a13.339,13.339,0,0,0-3.744,3.72l-1.368-.914a15.056,15.056,0,0,0-2.243,5.377l1.609.328a13.371,13.371,0,0,0-.011,5.277l-1.615.32a14.9,14.9,0,0,0,2.213,5.392l1.374-.909a13.338,13.338,0,0,0,3.72,3.744l-.647.967-.261.4-.005,0a15.06,15.06,0,0,0,5.377,2.243L288,448.2a13.393,13.393,0,0,0,5.282.008l.32,1.615a14.871,14.871,0,0,0,5.387-2.21l-.909-1.374a13.373,13.373,0,0,0,3.749-3.723l1.062.712.306.2a15.033,15.033,0,0,0,2.238-5.373l-1.609-.328a13.51,13.51,0,0,0,.013-5.286l1.615-.32a14.978,14.978,0,0,0-2.215-5.384Zm-7.167,13.478a7.282,7.282,0,1,1,2.05-10.092A7.281,7.281,0,0,1,294.694,441.121Z",
    transform: "translate(-271.899 -421.271)",
    fill: "#e9eaeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(522.237 258.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M1337.262,843.128v-2.472a2.033,2.033,0,0,0-2.033-2.033h-21.642a2.033,2.033,0,0,0-2.033,2.033v43.707h55.981V843.128Z",
    transform: "translate(-1311.555 -838.622)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M1369.864,867.808H1314.97l-3.414,39.733h55.708Z",
    transform: "translate(-1311.555 -861.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M1367.536,901.746h-55.981l5.94-39.238a2.348,2.348,0,0,1,2.321-2h51.232a2.348,2.348,0,0,1,2.321,2.7Z",
    transform: "translate(-1311.555 -856.005)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(565.939 246.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 12.827,
    cy: 12.827,
    r: 12.827,
    transform: "translate(0 18.14) rotate(-45)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M1560.678,829.808a13.3,13.3,0,1,1,13.3-13.3A13.313,13.313,0,0,1,1560.678,829.808Zm0-25.653a12.358,12.358,0,1,0,12.357,12.357A12.37,12.37,0,0,0,1560.678,804.155Z",
    transform: "translate(-1542.538 -798.373)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(11.966 9.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M1581.988,856.532v9.082c0,1.011,12.348,1.011,12.348,0v-9.082Zm6.8,4.823v2.574a.625.625,0,1,1-1.249,0v-2.58a1.519,1.519,0,1,1,1.249.006Z",
    transform: "translate(-1581.988 -850.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M1597.428,831.379h-1.25v-.612a3.843,3.843,0,1,0-7.686,0v.612h-1.25v-.612a5.093,5.093,0,1,1,10.185,0Z",
    transform: "translate(-1586.161 -825.675)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(381.035 299.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(56.246 42.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M-651.88,477.5l.793-18.4,19.352-6.3,3.522,23.364,1.673,12.116-26.609,5.968Z",
    transform: "translate(653.149 -452.801)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(0.363 67.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M-697.212,546.583s-1.9-40.291,18.4-57.421a66.321,66.321,0,0,1,38.7-16.021s1.3,10.974,9.271,11.212,13.563-6.9,14.4-12.493c0,0,28.678,5.4,46.286,27.612,11.42,14.593,10.627,26.014,11.42,42.822l-29.662,4.29,5.075,54.883-80.738,11.262-3.014-67.415Z",
    transform: "translate(697.259 -471.86)",
    fill: "#fd9926"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M0,25.207,1.939,0",
    transform: "translate(31.401 109.511)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(48.161 6.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M-657.632,438.511a33.74,33.74,0,0,0-1.745,13.96c.793,7.3,4.282,21.413,7.931,23.317s13.642,5.71,23.475-18.638S-651.6,406.946-657.632,438.511Z",
    transform: "translate(659.53 -423.903)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(36.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M-628.821,455.862v.174a3.206,3.206,0,0,0,3.22,3.262h.025l1.145-2.524a29.619,29.619,0,0,0,1.489-3.542c1.85-4.8,3.277-6.758,3.294-10.539.042-10.006-5.863-9.389-5.863-9.389a5.686,5.686,0,0,0-.227-.893c-4.107-15.85-16.2-14.844-24.685-11.535a19.056,19.056,0,0,0-3.443,1.544c-.826.422-1.585.846-2.253,1.249-7.443,4.5-10.58,2.6-10.58,2.6.5,1.511,3.009,2.529,3.009,2.529-4.4-.019-4.893-3.166-4.893-3.166-2.037,5.78,3.086,11.347,5.863,11.725a10.4,10.4,0,0,1-4.907-.02s8,12.866,34.383,2.844c.456,4.9,4.462,8.377,4.462,8.377l-.037,6.782",
    transform: "translate(669.051 -418.87)",
    fill: "#333f50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0 134.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M-697.081,524.948l31.066.3-.622,9.258-30.91,2.026Z",
    transform: "translate(697.546 -524.948)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(101.544 113.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M-614.63,532.514s-1.338-15.446-2.764-24.01",
    transform: "translate(617.394 -508.504)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(234 468.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M-410.437,604.305l-.078,2.53-.139,3.554h-46.34l-320.523-.013L-813.6,557.986l.009-2.17.014-3.534,31.989,52.2Z",
    transform: "translate(813.604 -552.283)",
    fill: "#f6f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M-781.6,604.481l-32.01-52.19h4.425l36.337,0,30.3,0,300.254.026,31.859,51.979Z",
    transform: "translate(813.606 -552.292)",
    fill: "#f6f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Table-2",
    "data-name": "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M-813.583,552.283v5.748l31.988,46.45,371.152-.176",
    transform: "translate(813.609 -552.283)",
    fill: "#f6f7f7",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M-501.507,609.189l-275.87.008L-813.6,556.785",
    transform: "translate(813.604 -551.082)",
    fill: "#f6f7f7",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M-746.9,604.469l-30.143.013-36.564-52.19",
    transform: "translate(813.606 -552.292)",
    fill: "#f6f7f7",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M-406.739,571.468l15.926,26.192-281.391.119",
    transform: "translate(793.984 -545.648)",
    fill: "#f6f7f7",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M-776.854,552.294l29.3,0,287.136.026",
    transform: "translate(823.415 -552.291)",
    fill: "#f6f7f7",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(413.102 495.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M-638.249,579.347l-33.986-5.408,2.955,18.269,12.9-2.687Z",
    transform: "translate(672.235 -573.939)",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(5.262 5.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M-663.475,588.142s19.685-8.491,22.908-9.7,3.627,2.552,0,4.3a246.928,246.928,0,0,1-25.876,10.083C-671.417,592.577-663.475,588.142-663.475,588.142Z",
    transform: "translate(668.081 -578.207)",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chracter_hand",
    "data-name": "Chracter hand",
    transform: "translate(408.175 436.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M-564.448,526.771l-34.509.868s-.951,14.123-3.965,16.027-43.145,22.049-48.221,25.063-16.654,1.586-22.682,8.724c-2.246,2.246-2.4,8.606-2.263,12.509a5.441,5.441,0,0,0,2.895,4.619l8.187,4.329a3.189,3.189,0,0,0,4.158-1.068,10.6,10.6,0,0,1,6.375-4.527c6.186-1.586,13.959-9.716,15.7-11.9,2.987-3.516,37.592-8.249,45.682-10.786s23.555-4.68,27.045-14.99C-563.226,547.315-564.448,526.771-564.448,526.771Z",
    transform: "translate(676.124 -526.771)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Laptop-2",
    "data-name": "Laptop",
    transform: "translate(314.133 436.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_2",
    "data-name": "laptop 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M-645.352,606.39l-91.561-5.643a6.54,6.54,0,0,1-6.095-5.78l-7.323-63.615a3.5,3.5,0,0,1,3.571-3.9l93.46,2.62a5.266,5.266,0,0,1,5.092,4.739l6.756,67.521A3.692,3.692,0,0,1-645.352,606.39Z",
    transform: "translate(750.355 -527.456)",
    fill: "#dbdbdb"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 7.174,
    cy: 7.368,
    rx: 7.174,
    ry: 7.368,
    transform: "translate(47.308 31.859)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin3);
export default __webpack_public_path__ + "static/media/login-3.3096c1a85b4cb524817bfd29b7943350.svg";
export { ForwardRef as ReactComponent };